import { axios } from "../../lib/axios";
import { encryptData } from "../EncryptDecrypt";

//Get Related Person Api Call
export const commonDisableAPI = ({ key, id, status = null, type = null, userOrgId = null }) => {

    let queryParams = `orgId=${userOrgId}`; 
    if (status) {
        queryParams += `&status=${status}`;
        if (type) {
            queryParams += `&type=${type}`;
        }
    } else if (type) {
        queryParams += `&type=${type}`;
    } 
    return axios.delete(`${key}/${id}?${queryParams}`); 
};

export const getPerson = ({ email = null, orgIds = null, isEnrollPatient = null }) => {
    if (isEnrollPatient && email && orgIds) {
        return axios.post("person/list", {
            email: encryptData(email?.toLowerCase()),
            orgIds,
            isEnrollPatient,
        })
    } else if (email) {
        return axios.post("person/list", { email: encryptData(email?.toLowerCase()) })
    } else if (orgIds) {
        return axios.post("person/list", { orgIds })
    }
}